import React, { FC, useEffect, useState } from "react";
import { ActionButtonIcon } from "./ActionButtonIcon";
import { ActivityInputValue } from "../../models/ProcessFlowConfig";
import { ActivityLog } from "../../models/ProcessFlowConfig";
import { ActivityService } from "../../services/ActivityService";
import { ExecuteAction1 } from "../../models/ProcessFlowConfig";
import { ProcessFlowAction } from "../../models/ProcessFlowConfig";
import { ProcessFlowStep } from "../../models/ProcessFlowConfig";
import { ISofProps } from "./SofPage";
import { FontIcon, MessageBarButton, Modal } from "@fluentui/react";
import { DefaultButton } from "@fluentui/react";
import { PrimaryButton } from "@fluentui/react";
import { Spinner } from "@fluentui/react";
import { SpinnerSize } from "@fluentui/react";
import { MessageBar } from "@fluentui/react";
import { mergeStyleSets } from "@fluentui/react";
import { MessageBarType } from "@fluentui/react";
import { DelayReasonModel } from "../../models/ProcessConfig";
import { LineHandling } from "../../models/LineHandling";
import { InputValue, SVLModel } from "../../models";
import { Nomination } from "../../models";
import { SofProcessor } from "../../services/SofProcessor";
import { toOrdinalString } from "../../services/Helper";
import DelayReasonsGrid from "./DelayReasonsGrid";
import moment from "moment";
import Moment from "react-moment";
import ShipVaporLineModal from "./ShipVaporLineModal";
import InputValuesForm from "./InputValuesForm";

interface Props extends ISofProps {
  step: ProcessFlowStep | undefined;
  surveyor?: string;
  onCancel(hasError: boolean): void;
  onStateChange(
    newState: string,
    lineHandling: LineHandling,
    activityLogs: ActivityLog[]
  ): void;
}

const classes = mergeStyleSets({
  container: {
    padding: 35,
    width: 520
  },
  header: {
    display: "flex",
    flex: "1 1 auto"
  },
  collapsibleHeader: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    padding: "8px 4px",
    marginTop: 12,
    borderTop: "1px solid #E2E6E8",
    fontWeight: "bolder",
    textTransform: "capitalize"
  },
  body: {
    maxHeight: "400px",
    overflow: "auto",
    overflowX: "hidden",
    padding: 4
  },
  footer: {
    marginTop: 35,
    display: "flex",
    direction: "rtl",
    justifyContent: "space-between"
  },
  title: {
    fontWeight: 500,
    fontSize: 18,
    lineHeight: 23,
    alignItems: "center",
    letterSpacing: "0.0015em",
      color: "#212529"
  },
  buttons: {
    borderRadius: 2,
    height: 52,
    width: 210
  },
  inputField: {
    fontSize: "22px !important",
    textAlign: "left"
  },
  calendar: {
    fontSize: 15
  },
  inputValue: {
    display: "flex",
    justifyContent: "space-between",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    padding: 6,
    marginBottom: 4
  }
});

const ActionModal: FC<Props> = (props: Props) => {
  const { activityLogs, nomination, lineHandling } = props;
  const { step, surveyor, correlationId, selectedState } = props;
  const [stepActivityLogs, setStepActivityLogs] = useState<ActivityLog[]>();
  const [description, setDescription] = useState<string>();
  const [createdOn, setCreatedOn] = useState<string>();
  const [startedOn, setStartedOn] = useState<string>();
  const [finishedOn, setFinishedOn] = useState<string>();
  const [order, setOrder] = useState(0);
  const [status, setStatus] = useState(0);
  const [inputValues, setInputValues] = useState<ActivityInputValue[]>();
  const [isDone, setIsDone] = useState(false);
  const [action, setAction] = useState<ProcessFlowAction>();
  const [actionDateTime, setActionDateTime] = useState<Date>();
  const [delayReason, setDelayReason] = useState<string>();
  const [delayReasons, setDelayReasons] = useState<DelayReasonModel>();
  const [isDelayReasonRequired, setIsDelayReasonRequired] = useState(false);
  const [isDelayReasonInvalid, setIsDelayReasonInvalid] = useState(false);
  const [inputValuesOption, setInputValuesOption] = useState<InputValue[]>();
  const [formInputValues, setFormInputValues] = useState<InputValue[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSVLIssue, setIsSVLIssue] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [showSVLModal, setShowSVLModal] = useState(false);

  const [stepActionCount, setStepActionCount] = useState<number>(0);

  const executeAction = async (
    actionId: number,
    inputValues: ActivityInputValue[] | undefined = undefined
  ) => {
    const activityService = new ActivityService();
    const lineHandlingNo = lineHandling.result
      ? lineHandling.result.lineHandlingNo
      : "0";

    const hasOfflineData =
      props.offlineData.filter((f) => f.lineHandlingNo === lineHandlingNo)
        .length > 0;

    if (step) {
      setIsLoading(true);

      const exeActivity = {
        lineHandlingNo,
        stepId: step.id,
        nominationNo: nomination && nomination.nominationNo,
        actionId,
        executionTime: getActionTimeString(),
        inputValues,
        order,
        surveyor,
        correlationId
      } as ExecuteAction1;

      try {
        const result = hasOfflineData
          ? await activityService.offlineExecuteAsync(
              exeActivity,
              props.account.accountIdentifier,
              () => props.insertOfflineData(lineHandlingNo, exeActivity)
            )
          : await activityService.executeActionAsync(
              exeActivity,
              props.account.accountIdentifier,
              () => props.insertOfflineData(lineHandlingNo, exeActivity)
            );
        let _lineHandling =
          lineHandling.result !== undefined
            ? lineHandling.result
            : ({} as LineHandling);

        if (result.result) {
          let nominations: Nomination[] | undefined = [];

          nominations = lineHandling.result && lineHandling.result.nominations;
          if (result.result.nominations && nominations) {
            for (let n of result.result.nominations) {
              let nom: Nomination | undefined = nominations.find(
                (f) =>
                  f.nominationNo.toLowerCase() === n.nominationNo.toLowerCase()
              );

              if (nom)
                nominations = [
                  ...nominations.filter(
                    (f) => f.nominationNo !== n.nominationNo
                  ),
                  { ...nom, ...n }
                ];
            }
          }

          _lineHandling = {
            ...props.lineHandling.result,
            ...result.result,
            nominations
          };
          props.setLineHandling(_lineHandling);
          if (nomination) {
            props.setActiveNomination(nomination.nominationNo, false);
          }
        }

        props.insertActivityLogs(result.activities, (activityLogs) => {
          if (result.newState && result.newState !== selectedState) {
            if (!(description && description.startsWith("Skip to "))) {
              props.onStateChange(result.newState, _lineHandling, activityLogs);
            } else {
              props.setSelectedState(result.newState);
            }
          }
        });

        onClose();
      } catch (ex) {
        const error = ex as Error;
        if (error) {
          setIsSVLIssue(
            error.message.toLowerCase().indexOf("ship vapor line") >= 0
          );
          setErrorMessage(error.message);
          setIsLoading(false);
        }
      }
    }
  };

  const getActionTimeString = () => {
    const actionDateTime = new Date();
    setActionDateTime(actionDateTime);
    return actionDateTime.toISOString();
  };

  const onClose = () => {
    props.onCancel(errorMessage ? true : false);
  };

  const actionClick = (processFlowAction: ProcessFlowAction) => {
    if (
      checkDelayReasons(processFlowAction) ||
      checkInputValues(processFlowAction)
    ) {
      setAction(processFlowAction);
    } else {
      executeAction(processFlowAction.id);
    }
  };

  const checkDelayReasons = (processFlowAction: ProcessFlowAction): boolean => {
    if (processFlowAction.delayReasons) {
      setDelayReasons(processFlowAction.delayReasons);

      const compareTo = startedOn ? startedOn : createdOn;
      const recommendedDuration = moment
        .utc(compareTo)
        .add(processFlowAction.delayReasons.interval, "m");

      const result = recommendedDuration.isSameOrBefore(
        moment(getActionTimeString())
      );
      setIsDelayReasonRequired(result);
      return result;
    }
    return false;
  };

  const checkInputValues = (processFlowAction: ProcessFlowAction): boolean => {
    if (processFlowAction.inputValues.length > 0) {
      setInputValuesOption(processFlowAction.inputValues);

      var _inputValues = processFlowAction.inputValues.filter(
        (f) => f.type !== "datetime"
      );
      if (_inputValues.length > 0) {
        setFormInputValues(_inputValues);
        return true;
      }
    }
    return false;
  };

  const replaceMergeFields = (text: string): string => {
    if (text.indexOf("{surveyor}") >= 0) {
      var _surveyor = surveyor
        ? surveyor
        : nomination
        ? nomination.surveyor
        : "surveyor";
      if (_surveyor) text = text.replace("{surveyor}", _surveyor);
    } else if (text.indexOf("{vesseltype}") >= 0) {
      if (lineHandling.result)
        text = text.replace("{vesseltype}", lineHandling.result.vesselType);
    } else if (text.indexOf("{n}") >= 0) {
      text = text.replace("{n}", toOrdinalString(order));
    }

    return text;
  };

  const onSubmit = (data: ActivityInputValue[]) => {
    if (action) {
      // input value from delay reason
      let delayReasonInputVal: ActivityInputValue[] = [];
      if (isDelayReasonRequired) {
        if (!delayReason || delayReason.trim() === "") {
          setIsDelayReasonInvalid(true);
          return;
        }

        delayReasonInputVal = [
          {
            caption: "Delay reason",
            type: "text",
            value: delayReason
          } as ActivityInputValue
        ];
      }

      executeAction(action.id, [...data, ...delayReasonInputVal]);
    }
  };

  const onConfirm = () => {
    if (action && isDelayReasonRequired) {
      if (!delayReason || delayReason.trim() === "") {
        setIsDelayReasonInvalid(true);
        return;
      } else {
        setIsDelayReasonInvalid(false);

        executeAction(action.id, [
          {
            caption: "Delay reason",
            type: "text",
            value: delayReason
          } as ActivityInputValue
        ]);
      }
    }
  };

  const onSVLConfirm = (nominations: SVLModel[]) => {
    setShowSVLModal(false);
    setErrorMessage(undefined);

    if (props.lineHandling.result === undefined) return;
    const _nominations = props.lineHandling.result.nominations.map((nom) => {
      const editedNom = nominations.find(
        (f) => f.nominationNo === nom.nominationNo
      );
      if (editedNom) {
        nom.shipVaporLine = editedNom.shipVaporLine;
        nom.shipVaporLineDescription = editedNom.shipVaporLineDescription;
      }
      return nom;
    });
    props.setLineHandling({
      ...props.lineHandling.result,
      nominations: _nominations
    });
  };

  const onOfflineSVLUpdate = (
    lineHandlingNo: string,
    nominations: SVLModel[]
  ) => {
    props.insertSVLOfflineData(lineHandlingNo, nominations);
  };

  useEffect(() => {
    if (activityLogs.result && step) {
      const acts = activityLogs.result.filter(
        (f) =>
          f.processStepId === step.id &&
          f.surveyor === surveyor &&
          (nomination === undefined ||
            f.nominationNo === nomination.nominationNo)
      );
      setStepActivityLogs(acts);
      const maxRepeationOrder = Math.max.apply(
        null,
        acts.map((s) => s.repetitionOrder)
      );
      const activeActivities = acts.filter(
        (f) => f.repetitionOrder === maxRepeationOrder
      );

      let inputVal: ActivityInputValue[] = [];
      for (var ctr = 0; ctr < activeActivities.length; ctr++) {
        const activeAct = activeActivities[ctr];
        if (activeAct.status === 0) {
          setCreatedOn(activeAct.logTime);
        } else if (activeAct.status === 1) {
          setStartedOn(activeAct.logTime);
        } else if (activeAct.status === 2) {
          setFinishedOn(activeAct.logTime);
        }
        if (activeAct.inputValues && activeAct.inputValues.length > 0) {
          inputVal = [...inputVal, ...activeAct.inputValues];
        }

        if (ctr === activeActivities.length - 1) {
          setStatus(activeAct.status);
          setDescription(activeAct.description);
          setIsDone(activeAct.status === 2);
        }
      }

      setOrder(maxRepeationOrder);
      setInputValues(inputVal);
      setActionDateTime(new Date());
    }
  }, [step]);

  useEffect(() => {
    if (step) {
      var actionCount = 0;

      var filteredActions = step.actions.filter((f) =>
        SofProcessor.checkConditions(
          f.displayConditions,
          lineHandling.result,
          nomination,
          []
        )
      );

      actionCount = filteredActions.length;

      if (lineHandling.result) {
        actionCount = filteredActions.filter(
          (f) => f.displayAt === status
        ).length;
      }

      setStepActionCount(actionCount);
    }
  }, [step, status]);

  return (
    <div className="modal-bg">
      <div className={`modal-right`}>
        <Modal
          isOpen={showSVLModal}
          styles={{ main: { width: 520, maxWidth: "unset !important" } }}
          onDismiss={() => setShowSVLModal(false)}
          isBlocking={true}
        >
          {props.lineHandling.result && (
            <ShipVaporLineModal
              lineHandling={props.lineHandling.result}
              onCancel={() => setShowSVLModal(false)}
              onOfflineUpdate={onOfflineSVLUpdate}
              onSuccess={onSVLConfirm}
            ></ShipVaporLineModal>
          )}
        </Modal>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between"
            // alignItems: "center",
          }}
        >
          <span className={classes.title}>Activity Details</span>
          <button className="btn-close" onClick={onClose}>
            <FontIcon iconName="cancel" />
          </button>
        </div>

        {errorMessage && (
          <div className="field">
            <MessageBar
              messageBarType={MessageBarType.error}
              onDismiss={onClose}
              dismissButtonAriaLabel="Close"
              actions={
                isSVLIssue ? (
                  <div>
                    <MessageBarButton onClick={() => setShowSVLModal(true)}>
                      Edit
                    </MessageBarButton>
                  </div>
                ) : undefined
              }
            >
              {errorMessage}
            </MessageBar>
          </div>
        )}
        <div
          style={{
            fontWeight: "bolder",
            textAlign: "left",
            margin: "10px 0 10px 0"
          }}
        >
          <span id="lbl-activity-title">{description}</span>
        </div>

        {isDone && startedOn && (
          <div style={{ fontSize: "14px" }}>
            <FontIcon iconName="clock" />
            &nbsp;
            <Moment format="ll HH:mm" local>
              {startedOn}
            </Moment>
          </div>
        )}
        {isDone && finishedOn && (
          <div style={{ fontSize: "14px" }}>
            <FontIcon iconName="clock" />
            &nbsp;
            <Moment format="ll HH:mm" local>
              {finishedOn}
            </Moment>
          </div>
        )}
        {!isDone && (
          <>
            <div style={{ textAlign: "left", fontSize: "14px" }}>
              <FontIcon iconName="clock" />
              &nbsp;
              <Moment format="ll HH:mm" local>
                {actionDateTime}
              </Moment>
            </div>

            <div>
              {action && (
                <div
                  style={{
                    fontWeight: "bolder",
                    textAlign: "left",
                    margin: "20px 0 10px 0"
                  }}
                >
                  {replaceMergeFields(action.name)}
                </div>
              )}
              {!action && (
                <div
                  className="ms-Grid"
                  dir="ltr"
                  style={{ padding: "0", marginTop: "20px" }}
                >
                  <div className="ms-Grid-row">
                    {step &&
                      step.actions
                        .filter((f) =>
                          SofProcessor.checkConditions(
                            f.displayConditions,
                            lineHandling.result,
                            nomination,
                            []
                          )
                        )
                        .map(
                          (action) =>
                            lineHandling.result &&
                            action.displayAt === status && (
                              <div
                                key={`action-button-${action.id}`}
                                className={`ms-Grid-col ${
                                  stepActionCount === 1 ? "ms-md12" : "ms-md6"
                                }`}
                                style={{ paddingLeft: "0px" }}
                              >
                                <div className="action-buttons">
                                  <button
                                    key={`action-${action.id}`}
                                    id={`btn-action-${action.id}`}
                                    style={{
                                      textAlign:
                                        stepActionCount === 1
                                          ? "center"
                                          : "left"
                                    }}
                                    className="btn-def"
                                    disabled={isLoading}
                                    onClick={() => actionClick(action)}
                                  >
                                    {isLoading ? (
                                      <Spinner
                                        size={SpinnerSize.small}
                                        style={{ display: "inline-block" }}
                                      />
                                    ) : (
                                      <ActionButtonIcon icon={action.icon} />
                                    )}
                                    &nbsp;{action.caption}
                                  </button>
                                </div>
                              </div>
                            )
                        )}
                  </div>
                </div>
              )}
            </div>

            {delayReasons && isDelayReasonRequired && (
              <>
                <DelayReasonsGrid
                  disabled={isLoading}
                  model={delayReasons}
                  onSelectionChange={(value: string) => {
                    setDelayReason(value);
                    setIsDelayReasonInvalid(
                      value === undefined ||
                        value === null ||
                        value.trim() === ""
                    );
                  }}
                />
                {isDelayReasonInvalid && (
                  <span
                    style={{
                      color: "red"
                    }}
                  >
                    Delay reason is required!
                  </span>
                )}
              </>
            )}

            {formInputValues.length > 0 && (
              <InputValuesForm
                startInputValues={inputValues}
                inputValues={formInputValues}
                disabled={isLoading}
                onClose={onClose}
                onSubmit={onSubmit}
              />
            )}
            {formInputValues.length <= 0 && action && (
              <div className="ms-Grid" dir="ltr" style={{ marginTop: "20px" }}>
                <div className="ms-Grid-row">
                  <div
                    className="ms-Grid-col ms-md6"
                    style={{ paddingLeft: "0px", paddingRight: "5px" }}
                  >
                    <PrimaryButton
                      className="action-button-submit"
                      id="btn-confirm-action"
                      type="submit"
                      onClick={onConfirm}
                      disabled={isLoading}
                      style={{ height: "52px" }}
                    >
                      Confirm
                    </PrimaryButton>
                  </div>
                  <div
                    className="ms-Grid-col ms-md6"
                    style={{ paddingLeft: "5px", paddingRight: "0px" }}
                  >
                    <DefaultButton
                      className="action-button-submit"
                      id="btn-cancel-action"
                      type="button"
                      onClick={onClose}
                      disabled={isLoading}
                      style={{ height: "52px" }}
                    >
                      Cancel
                    </DefaultButton>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default ActionModal;
